import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { EReducers, IReducers } from 'app/store/reducers';
import { viewMessage } from 'app/store/actions/message.action';
import { takeUntil } from 'rxjs/operators';
import {
  EMessageStateStatus,
  IMessage,
  IMessageState,
} from 'app/store/models/message.model';
import { Subject } from 'rxjs';
import { SessionService } from 'app/store/services/session.service';
import { IUserSessionData } from 'app/store/models/user.model';

@Component({
  selector: 'app-contact-conversation',
  templateUrl: './contact-conversation.component.html',
  styleUrls: ['./contact-conversation.component.scss'],
})
export class ContactConversationComponent implements OnInit, OnDestroy {
  @Input() messageId: number;

  messages: IMessage[];
  sessionData: IUserSessionData;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<IReducers>,
    private sessionService: SessionService
  ) {}

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        this.store
          .select(EReducers.MESSAGE)
          .pipe(takeUntil(this.destroy$))
          .subscribe((state: IMessageState) => {
            if (state.status === EMessageStateStatus.READY) {
              this.messages = state.current_messages;
            }
          });
      });

    this.store.dispatch(
      viewMessage({
        id_message: this.messageId,
      })
    );
  }
}
